<template>
<v-card v-show="shop !== 0" class="dash-card">
    <shop-users ref="shopUsersRef" :shopID="shop" style="display:none"></shop-users>
    <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
        <v-toolbar-title>
            {{getString('Classifica clienti')}}
        </v-toolbar-title>
         <v-spacer></v-spacer>
        <v-toolbar-side-icon @click="hidden = !hidden">
          <v-icon class="q-text-whitesmoke" :class="{'module-closed' : !hidden}" >arrow_drop_down</v-icon>
        </v-toolbar-side-icon>
    </v-toolbar>
    <v-layout row wrap v-show="!hidden">
        <v-flex xs12 sm12 md12 lg12>
            <v-card>
                 <v-toolbar class="q-whitesmoke-bk q-text-whitesmoke elevation-0 no-cradius" height="50px">
                   <v-layout row style="margin-top:25px">
                        <v-flex xs5>
                            <v-menu ref="rankDateStart" :close-on-content-click="false"  :nudge-right="40" :return-value.sync="dateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="dateStart" :label="getString('Da')" prepend-icon="event" readonly color="red lighten-2"></v-text-field>
                                <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2" v-model="dateStart" @input="$refs.rankDateStart.save(dateStart)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs5>
                            <v-menu ref="rankDateEnd" :close-on-content-click="false"  :nudge-right="40" :return-value.sync="dateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="dateEnd" :label="getString('A')" prepend-icon="event" readonly color="red lighten-2"></v-text-field>
                                <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2" v-model="dateEnd" @input="$refs.rankDateEnd.save(dateEnd)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                   <v-text-field v-model="search" :placeholder="getString('Cerca qui')" />
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <v-flex slot="activator">
                            <v-btn @click="getStats" color="red lighten-2" class="no-cradius elevation-0 q-text-whitesmoke">
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                        <span>{{getString('Aggiorna i dati')}}</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="headers" :items="resStats" :search="search" :rows-per-page-items="[10,25,{text:getString('Tutto'),value:-1}]" :rows-per-page-text="getString('Prenotazioni per pagina')" :no-data-text="getString('Dati non disponibili')"
                        :loading="isLoading" class="elevation-0">
                        <template slot="items" slot-scope="props">
                          <tr style="cursor:pointer" @click="openClientCard(props.item)">
                            <td class="text-xs-left">{{props.item.position}}</td>
                            <td>
                                <v-list-tile-avatar>
                                    <img :src="defaultAvatar(props.item.photo)">
                                </v-list-tile-avatar>
                            </td>
                            <td class="text-xs-left">{{props.item.name}}</td>
                            <td class="text-xs-left">{{props.item.surname}}</td>
                            <td class="text-xs-left">{{props.item.numReservation}}</td>
                          </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</v-card>
</template>

<script>
import ajax from '../../../ajax'
import Utils from '../../../utils'
import Chart from 'chart.js'
import moment from 'moment'
import ShopUsers from './ShopUsers'
let ut = new Utils()
export default {
  name: 'StatsLadderCard',
  components: { ShopUsers },
  mounted: function() {
    
    let self = this
    let ut = new Utils()
  },
  computed: {
    locale: function() {
      return this.$store.state.currentTranslator.locale
    },
    headers: function() {
      let result = []
      let self = this
      if (Object.keys(this.resStats).length > 0) {
        let temp = [
          self.getString('Posizione'),
          self.getString('Foto:'),
          self.getString('Nome Cliente:name'),
          self.getString('Cognome Cliente:surname'),
          self.getString('Numero prenotazioni')
        ]
        temp.forEach(element => {
          result.push({
            text: self.getString(element.split(':')[0]),
            align: 'left',
            sortable: true,
            value: element.split(':')[1]
          })
        })
        return result
      }
      return []
    }
  },
  data: () => {
    return {
      h: null,
      lasts: [],
      hidden: true,
      shop: 0,
      isLoading: '',
      search: '',
      resStats: [],
      dateStart: moment().startOf('year').format('YYYY-MM-DD'),
      dateEnd: moment().endOf('year').format('YYYY-MM-DD')
    }
  },
  methods: {
    formatTitle: function(d) {
      var options = {
        weekday: 'long'
      }
      return ut.Capitalize(new Date().toLocaleString(this.locale, options))
    },
    defaultAvatar: function(url) {
      if (
        url === null ||
        url === 'images/u_placeholder.jpg' ||
        url === '/images/u_placeholder.jpg'
      ) {
        return (
          '/../../../../static/img/default-avatar.png'
        )
      } else return ajax.baseUrl() + url
    },
    setVisibility: function(vis) {
      this.hidden = vis
    },
    getStats: function() {
      let self = this
      this.isLoading = true
      ajax.axios
        .get(ajax.baseUrl() + '/admin/dashboard/ranking/shop/'+self.shop+'/from/'+self.dateStart+'/to/'+ self.dateEnd, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.isLoading = false
          self.resStats = response.data.data
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
        })
    },
    init: function(shop) {
      this.shop = shop
      if (this.shop !== 0) {
        this.getStats()
      }
    },
    openClientCard: function(item) {
      this.$refs.shopUsersRef.openDetails({ idUser: item.idUser })
    },
    getString: function(key) {
      return this.$store.state.currentTranslator.getString(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backend/pieces/StatsLadderCard.vue